export default class ProductCategory {
    code!: string;
    description!: string;
}
